import axios from "../api/api";
import { useAuth } from "./useAuth";

export const useApi = () => {
    const { getToken } = useAuth();
    axios.defaults.headers.common['Authorization'] = `Bearer ${getToken()}`;
    return axios;
}